export enum BehaviourEvent {
  Show = "show",
  ShowDetails = "showDetails",
  Form = "form",
  Instructions = "instructions",
  Link = "link",
  Msa = "msa",
  ShowLocations = "show-locations",
  ShowNewLocation = "show-new-location",
  Teleservice = "teleservice",
  LinkIneligible = "link-ineligible",
  ShowUnexpected = "show-unexpected",
  Close = "close",
  RetourLogement = "retour-logement",
  SimulationCaf = "simulation-caf",
  Email = "email",
  ShowUnexpectedAmountLink = "show-unexpected-amount-link",
}
